import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import Auth from '../auth/Auth'

class AuthenticatedRoute extends Component {
  render() {
    const { component: Component, ...rest } = this.props

    if (Auth.isAuthenticated()) {
      return <Route {...rest} render={props => <Component {...props} />} />
    } else {
      return (
        <Route
          {...rest}
          render={props => (
            <Redirect
              to={{ pathname: '/login', state: { from: props.location } }}
            />
          )}
        />
      )
    }
  }
}

export default AuthenticatedRoute



// WEBPACK FOOTER //
// ./src/containers/AuthenticatedRoute.js